module.exports = __webpack_public_path__ + "img/343w.387fdad.jpg";